import React from 'react';
import logoImg from '@/assets/yacht-values-logo.png';

type LogoProps = {
  variant?: 'default' | 'inverse';
  size?: 'sm' | 'md' | 'lg';
  markOnly?: boolean;
  className?: string;
};

const fullSize: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'h-auto w-[148px] md:w-[176px]',
  md: 'h-auto w-[188px] md:w-[256px] lg:w-[288px]',
  lg: 'h-auto w-[248px] md:w-[320px] lg:w-[360px]',
};
const markSize: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'h-7',
  md: 'h-9 md:h-10',
  lg: 'h-11 md:h-12',
};

export default function Logo({ variant = 'default', size = 'md', markOnly = false, className = '' }: LogoProps) {
  const isInverse = variant === 'inverse';
  const heightClass = markOnly ? markSize[size] : fullSize[size];

  return (
    <img
      src={logoImg}
      alt="YachtValues — private yacht valuation and market intelligence"
      draggable={false}
      width={1672}
      height={300}
      className={`${heightClass} select-none ${markOnly ? 'object-cover object-left' : 'max-w-full object-contain object-left'} ${isInverse ? 'brightness-0 invert' : ''} ${className}`}
      style={markOnly ? { aspectRatio: '1 / 1' } : undefined}
    />
  );
}
